import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/config';
import { Observable } from 'rxjs';
import { DynamicStats, EmcSearchOutput, PageInfo, ResponsePackage } from 'shared-lib';
import { Filter } from '../models/dynamic-filter.model';
import { CimSubstationPopupDto } from '../models/cim-substation-map.model';

@Injectable({
  providedIn: 'root',
})
export class TaggedSubstationService {
  private pathApi: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private config: AppConfig,
  ) {
    this.pathApi = this.config.setting['pathApi'] + 'cim/TaggedSubstation/';
  }

  getPopupInfo(id: number) {
    return this.http.get<ResponsePackage<CimSubstationPopupDto>>(`${this.pathApi}getPopupInfo/${id}`, { headers: this.headers, observe: 'response' });
  }

  getByGuid(guid: string, utilityId: number): Observable<any> {
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}getByGuid?guid=${guid}&utilityId=${utilityId}`,
      { headers: this.headers, observe: 'response' },
    );
  }

  assignSubstation(dataIn: any): Observable<any> {
    return this.http.post<ResponsePackage<string>>(
      `${this.pathApi}assign`,
      dataIn,
      { observe: 'response' },
    );
  }

  getAll(dataIn: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, dataIn, {
      observe: 'response',
    });
  }

  getStatsDynamic(obj: DynamicStats): Observable<any> {
    return this.http.post(`${this.pathApi}getStatsDynamic`, obj, {
      headers: this.headers,
      observe: 'response',
    });
  }

  downloadDynamic(originalFilter: Filter): Observable<any> {
    const filterCopy: Filter = {
      pageInfo: new PageInfo(-1, -1),
      filterParams: {
        ...originalFilter.filterParams,
        selectedAreas: originalFilter.filterParams.selectedAreaModels?.map(a => a.id) || [],
        selectedUsers: originalFilter.filterParams.selectedUserModels?.map(u => u.id) || [],
        selectedTransmissionStations: originalFilter.filterParams.selectedTsModels?.map(ts => ts.id) || [],
      },
      dynamicFilters: originalFilter.dynamicFilters.map(df => ({
        ...df
      })),
      searchObject : new EmcSearchOutput(),
      utilityId: originalFilter.utilityId,
      substationTemplateId: originalFilter.substationTemplateId
    };

    return this.http.post(`${this.pathApi}downloadFileDynamic`, filterCopy);
  }

  getInstancesForAsset(entityType: number, assetGuid: string, substationTemplateId?: number | null) {
    return this.http.get<ResponsePackage<any>>(
      `${this.pathApi}getInstancesForAsset/${entityType}/${assetGuid}/${substationTemplateId ? substationTemplateId : ''}`,
      { headers: this.headers, observe: 'response' }
    );
  }

  getEquipmentForAsset(assetGuid: string, substationTemplateId?: number | null) {
    return this.http.get<ResponsePackage<any>>(
      `${this.pathApi}getEquipmentForAsset/${assetGuid}/${substationTemplateId ? substationTemplateId : ''}`,
      { headers: this.headers, observe: 'response' }
    );
  }

  getSubstationDataQuality(id: number): Observable<any> {
    return this.http.get(`${this.pathApi}getSubstationDataQuality/${id}`, {
      observe: 'response',
    });
  }

  rejectSubstationTemplate(dataIn: any): Observable<any> {
      return this.http.post(`${this.pathApi}rejectSubstation`, dataIn, {
        headers: this.headers,
        observe: 'response',
      });
    }

    approveSubstationTemplate(dataIn: any): Observable<any> {
      return this.http.post(`${this.pathApi}approveSubstation`, dataIn, {
        headers: this.headers,
        observe: 'response',
      });
    }

    recall(id: number): Observable<any> {
      return this.http.post(`${this.pathApi}recall/${id}`, {}, {
        headers: this.headers,
        observe: 'response',
      });
    }

    getMapDetails(id: number) {
      return this.http.get<ResponsePackage<any>>(`${this.pathApi}getMapDetails/${id}`, { headers: this.headers, observe: 'response' });
    }
}
